<template lang="pug">

v-card.mb-2
  v-card-title.grey.lighten-4
    .title It Termine zu Tickets

  v-tabs
    template(v-for="perspective in perspectives")
      v-tab {{perspective}}
      v-tab-item.mt-3
        template(v-for="termine,name in items")
          v-card.mt-2
            v-card-text
              span.table_title.mt-3 {{name}}
              v-data-table(:items="termine" :headers="headers" hide-actions)
                template(slot="items" slot-scope="{item}")

                  tr(v-if="new Date(item.tag) >= heute && perspective == 'anstehend'")
                    td {{item.projekt}}
                    td {{new Date(item.tag).toLocaleDateString('de-DE')}}
                    td {{item.beginn}}
                    td {{item.ticket_ids}}
                  
                  tr(v-if="new Date(item.tag) < heute && perspective == 'vergangen'")
                    td {{item.projekt}}
                    td {{new Date(item.tag).toLocaleDateString('de-DE')}}
                    //- td {{moment(new Date(item.tag) ).format("DD.MM.YYYY")}}
                    td {{item.beginn}}
                    td {{item.ticket_ids}} 

</template>

<style lang="stylus">
.table-slim.table-slim.table-slim.table-slim
  padding-left 0
  padding-right 4px

.table_title {
  font-size: 16px !important;
  font-weight: 500;
  line-height: 1 !important;
  letter-spacing: 0.02em !important;
  font-family: 'Roboto', sans-serif !important;
} 

.pctable45 {
  width: 45%
}

.pctable25 {
  width: 25%
}
.pctable15 {
  width: 15%
}
</style>

<script>
import gql from 'graphql-tag'
import moment from 'moment'

window.moment = moment

export default {
  props: ['extra'],
  data() {
    return {
      headers: [
        { text: "Projekt", sortable: false, class: "table-slim pctable45" },
        { text: "Tag", sortable: false, class: "table-slim pctable15" },
        { text: "Uhrzeit", sortable: false, class: "table-slim pctable15" },
        { text: "Ticketnummer(n)", sortable: false, class: "table-slim pctable25" },
      ],
      anstehend: true,
      heute: new Date(),
      perspectives: ["anstehend", "vergangen"]
    }
  },
  computed: {
    items() {
      return JSON.parse(this.extra && this.extra.content || null) || []
    }
  },
}
</script>
 